import ApiService from "@/core/services/api.service";

// action types
export const FETCH_STORAGE_RECEIPTS = "fetchStorageReceipts";
export const FETCH_STORAGE_RECEIPT = "fetchStorageReceipt";
// export const FETCH_COMPANY_STORAGE_RECEIPTS = "fetchCompanyStorageReceipts";
export const FETCH_ADMIN_STORAGE_RECEIPTS = "fetchAdminStorageReceipts";

// mutation types
export const SET_STORAGE_RECEIPTS = "setStorageReceipts";
export const SET_STORAGE_RECEIPTS_PAGINATION = "setStorageReceiptsPagination";
export const SET_STORAGE_RECEIPT = "setStorageReceipt";

const state = {
  storageReceipts: [],
  storageReceiptsPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  storageReceipt: {}
};

const getters = {
  storageReceipts(state) {
    return state.storageReceipts;
  },

  storageReceiptsPagination(state) {
    return state.storageReceiptsPagination;
  },

  storageReceipt(state) {
    return state.storageReceipt;
  }
};

const actions = {
  [FETCH_STORAGE_RECEIPTS](context) {
    return new Promise((resolve, reject) => {
      ApiService.query("receipts/storage", {
        params: {
          page: context.state.storageReceiptsPagination.currentPage
        }
      })
        .then(({ data }) => {
          context.commit(SET_STORAGE_RECEIPTS, data.data);
          context.commit(SET_STORAGE_RECEIPTS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_STORAGE_RECEIPT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get("receipts/storage", id)
        .then(({ data }) => {
          context.commit(SET_STORAGE_RECEIPT, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_ADMIN_STORAGE_RECEIPTS](context) {
    return new Promise((resolve, reject) => {
      ApiService.query("admin/receipts/storage", {
        params: {
          page: context.state.storageReceiptsPagination.currentPage
        }
      })
        .then(({ data }) => {
          context.commit(SET_STORAGE_RECEIPTS, data.data);
          context.commit(SET_STORAGE_RECEIPTS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_STORAGE_RECEIPTS](state, data) {
    state.storageReceipts = data;
  },
  [SET_STORAGE_RECEIPTS_PAGINATION](state, data) {
    state.storageReceiptsPagination = data;
  },
  [SET_STORAGE_RECEIPT](state, storageReceipt) {
    state.storageReceipt = storageReceipt;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
